export default {
  officeList: state => {
    return state.offices.results;
  }
};
